import { render, staticRenderFns } from "./ImageAndBodyCopy.vue?vue&type=template&id=773532a0&scoped=true&"
import script from "./ImageAndBodyCopy.vue?vue&type=script&lang=js&"
export * from "./ImageAndBodyCopy.vue?vue&type=script&lang=js&"
import style0 from "./ImageAndBodyCopy.vue?vue&type=style&index=0&id=773532a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773532a0",
  null
  
)

export default component.exports